import React from 'react';
import { Input } from 'antd';
import { injectIntl } from 'react-intl';
import styles from './CandidateSegmentsAndCampaignsHeader.module.scss';
import CandidateSegmentsAndCampaignsFilter from '../CandidateSegmentsAndCampaignsFilter/CandidateSegmentsAndCampaignsFilter';
import placeholder from '../Placeholders/PlaceholdersMessages';

function CandidateSegmentsAndCampaignsHeader(props) {
  const {
    segments,
    candidateId,
    fetchCandidateSegmentsAndCampaigns,
    segmentAggregation,
    onSearchChange,
    onSearch,
    searchTerm,
    selectedCreatedByFilterOptions,
    setSelectedCreatedByFilterOptions,
    isCandidateViewHeaderVisible,
    isFilterPopoverVisible,
    setFilterPopoverVisbility,
    intl,
  } = props;
  return (
    <div className={styles.listsAndCampaignsTabsHeader}>
      <div className={styles.searchAndFilter}>
        <Input.Search
          size="default"
          placeholder={intl.formatMessage({ ...placeholder.searchLabel })}
          allowClear
          className={styles.listsAndCampaignsInputSearch}
          onSearch={onSearch}
          onChange={onSearchChange}
          value={searchTerm}
        />
        <CandidateSegmentsAndCampaignsFilter
          segments={segments}
          candidateId={candidateId}
          fetchCandidateSegmentsAndCampaigns={fetchCandidateSegmentsAndCampaigns}
          segmentAggregation={segmentAggregation}
          selectedCreatedByFilterOptions={selectedCreatedByFilterOptions}
          setSelectedCreatedByFilterOptions={setSelectedCreatedByFilterOptions}
          searchTerm={searchTerm}
          isCandidateViewHeaderVisible={isCandidateViewHeaderVisible}
          isFilterPopoverVisible={isFilterPopoverVisible}
          setFilterPopoverVisbility={setFilterPopoverVisbility}
        />
      </div>
    </div>
  );
}

export default injectIntl(CandidateSegmentsAndCampaignsHeader);
export { CandidateSegmentsAndCampaignsHeader as CandidateSegmentsAndCampaignsHeaderWithoutInjectIntl };
